import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-body p-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-px text-center py-20 my-10" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "fs-2x fw-bolder mb-10" }, "Coming Soon!"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 fs-5 fw-bold mb-13" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Stay tuned.")
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}